import { LicenseInfo } from "@mui/x-license";
import { type FC, useEffect } from "react";

import { getRuntimeEnv } from "~/utils/getRuntimeEnv";

function applyMuiLicenseKey() {
  const key = getRuntimeEnv()?.VITE_MUI_LICENSE_KEY?.trim();
  if (key) {
    LicenseInfo.setLicenseKey(key);
  }
}

export const LicenseInit: FC = () => {
  // useEffect не виконується на SSR — без синхронного виклику MUI X логував би "Missing license key"
  applyMuiLicenseKey();

  useEffect(() => {
    applyMuiLicenseKey();
  }, []);

  return null;
};
